// extracted by mini-css-extract-plugin
module.exports = {"photoeditor-container":"photo-editor_photoeditor-container__26uTU","photoeditor":"photo-editor_photoeditor__2yjy1"};